import { createRouter, createWebHistory } from 'vue-router'
import MainView from '@/views/MainView.vue'
import AuthorView from '@/views/AuthorView.vue'
import ProjectView from '@/views/ProjectView.vue'
import ProjectsView from '@/views/ProjectsView.vue'
import { updateMeta, setJsonLd, getGlobalSchema, getCanonical } from '@/utils/seo.js'
import CommercialOfferView from '@/views/CommercialOfferView.vue'
import { getSeoForPath } from '@/config/routeSeo.ts'

const SITE = 'https://chapterfour.ru'

const router = createRouter({
  history: createWebHistory(import.meta.env.BASE_URL),
  routes: [
    {
      path: '/',
      name: 'Main',
      meta: { title: 'Главная' },
      component: MainView,
    },
    {
      path: '/commercial',
      name: 'commercial',
      component: () => import('../views/CommercialView.vue'),
    },
    {
      path: '/broadcast',
      name: 'broadcast',
      component: () => import('../views/BroadcastView.vue'),
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('../views/AboutView.vue'),
    },
    {
      path: '/3d',
      name: '3d',
      component: () => import('../views/3DView.vue'),
    },
    {
      path: '/sound',
      name: 'sound',
      component: () => import('../views/SoundView.vue'),
    },
    {
      path: '/test',
      name: 'test',
      component: () => import('../views/test.vue'),
    },
    {
      path: '/author/:name',
      name: 'author',
      component: AuthorView,
    },
    {
      path: '/author/:name/kp',
      name: 'author-kp',
      meta: { title: 'Коммерческое предложение' },
      component: CommercialOfferView,
    },
    {
      path: '/project/:id',
      name: 'project',
      component: ProjectView,
    },
    {
      path: '/projects',
      name: 'projects',
      component: ProjectsView,
    },
    {
      path: '/presentation',
      name: 'presentation',
      component: () => import('../views/PresentationView.vue'),
    },
    {
      path: '/presentation/:slug',
      name: 'presentation-article',
      component: () => import('../views/PresentationView.vue'),
      meta: { title: 'Презентация' },
    },
    {
      path: '/contact',
      name: 'contact',
      component: () => import('../views/ContactView.vue'),
    },
    {
      path: '/policy',
      name: 'policy',
      component: () => import('../views/PolicyView.vue'),
      meta: { title: 'Политика конфиденциальности' },
    },
    {
      path: '/terms',
      name: 'terms',
      component: () => import('../views/TermsView.vue'),
      meta: { title: 'Пользовательское соглашение' },
    },
    {
      path: '/develop',
      name: 'develop',
      component: () => import('../views/ProductionView.vue'),
      meta: { title: 'Разработка' },
    },
    {
      path: '/kp',
      name: 'kp',
      meta: {
        title: 'Коммерческое предложение',
      },
      component: CommercialOfferView,
    },
  ],
  scrollBehavior() {
    return { top: 0 }
  },
})

// SEO: мета и JSON-LD при каждой навигации
router.beforeEach((to) => {
  const seo = getSeoForPath(to.path, to.params)
  updateMeta(seo)

  // Удаляем страничный JSON-LD (например VideoObject), оставленный предыдущей страницей
  document.getElementById('seo-json-ld-extra')?.remove()

  // Глобальная разметка на всех страницах; страница может дописать свой JSON-LD через addJsonLd
  setJsonLd(getGlobalSchema())

  // Сбрасываем overflow на body
  document.body.style.overflow = ''

  return true
})

export default router
export { getSeoForPath, getCanonical, SITE }
